"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GameConstants = /** @class */ (function () {
    function GameConstants() {
    }
    GameConstants.VERSION = "0.0";
    GameConstants.ASSETS_PATH = "assets";
    GameConstants.DEVELOPMENT = false;
    GameConstants.VERBOSE = true;
    GameConstants.GAME_WIDTH = 768;
    GameConstants.GAME_HEIGHT = 1024;
    GameConstants.SHOW_BOUNDING_AREAS = false;
    GameConstants.GAMEMODE_ENDLESS = "endless";
    GameConstants.GAMEMODE_TIME = "time";
    GameConstants.GAMEMODE_MOVES = "moves";
    GameConstants.CARD_WIDTH = 80;
    GameConstants.CARD_HEIGHT = 109;
    GameConstants.DEALPILE_Y = 320;
    GameConstants.PILES_Y = GameConstants.DEALPILE_Y + 100;
    GameConstants.BITMAP_SIZE = 64;
    GameConstants.CLASSIC_THEME = 0;
    GameConstants.NINJA_THEME = 1;
    GameConstants.NO_FINAL = -1;
    GameConstants.FINAL_WIN = 0;
    GameConstants.FINAL_LOSE = 1;
    GameConstants.FINAL_OUT_OF_MOVES = 2;
    GameConstants.FINAL_TIME = 3;
    GameConstants.ABRUPT_END = 4;
    GameConstants.WAITING_INVITED = 0;
    GameConstants.WAITING_NO_OPPONENT = 1;
    GameConstants.WAITING_ACCEPTED = 2;
    GameConstants.WAITING_RANDOM = 3;
    GameConstants.DEAL_ONE = 0;
    GameConstants.DEAL_THREE = 1;
    GameConstants.TWITTER = "twitter";
    GameConstants.FACEBOOK = "facebook";
    GameConstants.RED_SQUARE = "red-square";
    GameConstants.GREEN_SQUARE = "green-square";
    GameConstants.OLIVE_GREEN_SQUARE = "olive-green-square";
    GameConstants.LEMON_CHIFFON_SQUARE = "lemon-chiffon-square";
    GameConstants.BLUE_SQUARE = "blue-square";
    GameConstants.LIGHT_BLUE_SQUARE = "light-blue-square";
    GameConstants.WHITE_SQUARE = "white-square";
    GameConstants.BLACK_SQUARE = "black-square";
    GameConstants.GRAY_SQUARE = "gray-square";
    GameConstants.YELLOW = "yellow";
    GameConstants.TIME_FADE = 450;
    GameConstants.AUDIO_STATE_KEY = "solitaire-gold-audio";
    GameConstants.SCORE_STATE_KEY = "solitaire-gold-score";
    GameConstants.isMobile = {
        Android: function () {
            return navigator.userAgent.match(/Android/i);
        },
        BlackBerry: function () {
            return navigator.userAgent.match(/BlackBerry/i);
        },
        iOS: function () {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
        },
        Opera: function () {
            return navigator.userAgent.match(/Opera Mini/i);
        },
        Windows: function () {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
        },
        any: function () {
            return (GameConstants.isMobile.Android() || GameConstants.isMobile.BlackBerry() || GameConstants.isMobile.iOS() || GameConstants.isMobile.Opera() || GameConstants.isMobile.Windows());
        }
    };
    return GameConstants;
}());
exports.GameConstants = GameConstants;
